const EDCInfo = () => {
    return(
        <>
          <p>
            We have developed a special tool for EDC15 to patch .bin files
            directly with our custom code for mapswitch.
            Check out the video above to see how to use the multimap with brake
            and cruise control set.
          </p>
          <p>
            <strong>Note:</strong>
          </p>
          <ul>
            <li>
              VIN entered must be from engine page in VCDS. Contact us if VCDS
              doesn't show VIN.
            </li>
            <li>
              Soft coding: all 5 digits must be same as shown in engine page in
              VCDS. (for example: 00102, 00002, 00005, etc.)
            </li>
            <li>
              Choose all options correctly and all information must be correct.
              There will be no refunds.
            </li>
            <li>
              We are not responsible for any brick or damage to your
              engine/car/cat/dog, etc! By pressing the "submit" button, you
              agree to the T&amp;Cs listed above.
            </li>
          </ul>
          <p>
            <strong>Pedal Option:</strong>
          </p>
          <ol>
            <li>Press Accelerator pedal 100% and hold</li>
            <li>Brake pedal to switch</li>
          </ol>
          <p>
            <strong>Cruise Option:</strong>
          </p>
          <ol>
            <li>Press brake/clutch pedal and hold it</li>
            <li>Press cruise set to switch maps</li>
          </ol>
          <p>
            <em>
              Load file in WinOLS as a version of stock file or you will brick
              ECU with checksum issue! We are not responsible for any brick or
              damage to your engine/car/cat/dog! The patch has a copy protection
              code to lock it 1 car. It will work only on the car to which the
              file belongs.
            </em>
          </p>
        </>
    )
}
export default EDCInfo